import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export type ServiceForListing = {
  id: string;
  title: string;
  slug: string;
  listing_id: string;
  seller_user_id: string;
  starting_price_cents: number;
};

/**
 * Map of listing_id -> marketplace service backing that listing.
 * Only services readable under the public/board policy are returned.
 */
export function useServiceListingMap() {
  const { data } = useQuery({
    queryKey: ["service-listing-map"],
    staleTime: 60_000,
    queryFn: async (): Promise<Record<string, ServiceForListing>> => {
      const { data } = await supabase
        .from("marketplace_services")
        .select("id, title, slug, listing_id, seller_user_id, starting_price_cents")
        .not("listing_id", "is", null)
        .eq("status", "active");
      const map: Record<string, ServiceForListing> = {};
      for (const s of (data ?? []) as ServiceForListing[]) {
        if (s.listing_id) map[s.listing_id] = s;
      }
      return map;
    },
  });
  return data ?? {};
}
